import { render } from "./CardWhiteBpp.vue?vue&type=template&id=2d86dd8a&scoped=true"
import script from "./CardWhiteBpp.vue?vue&type=script&lang=js"
export * from "./CardWhiteBpp.vue?vue&type=script&lang=js"

import "./CardWhiteBpp.vue?vue&type=style&index=0&id=2d86dd8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d86dd8a"]])

export default __exports__